export default __webpack_public_path__ + "static/media/safemoon.258bd2b0.jpeg";